module.exports = __webpack_public_path__ + "img/kiosk-search-categories.7e57fbce.png";